export default {
  getEmailBadge(state) {
    return state.emailBadge;
  },

  getQuotesValueBadge(state) {
    return state.quotesValueBadge;
  },

  getQuotesBadge(state) {
    return state.quotesBadge;
  },

  getConversion(state) {
    return state.conversion;
  },

  getNationality(state) {
    return state.nationality;
  },

  getStagioni(state) {
    return state.stagioni;
  },

  getTotalRequest(state) {
    return state.totalRequest;
  },

  getNationalityConversion(state) {
    return state.nationalityConversion;
  },
};
